import Link from "next/link";
import { FC } from "react";

interface Props {
  href: string;
  name: string;
  imgUrl: string;
}

const CategoryItem: FC<Props> = ({ href, name, imgUrl }): JSX.Element => {
  return (
    <Link
      href={href}
      className="flex items-center hover:no-underline hover:bg-gray-100 border border-gray-100 bg-white"
    >
      <div
        style={{
          backgroundImage: `url(${imgUrl})`,
        }}
        className="w-[60px] h-[60px] bg-no-repeat bg-cover bg-center flex-shrink-0"
      ></div>
      <div className="flex items-center justify-between flex-1">
        <p className="py-6 px-12 text-sm">{name}</p>
        <i className="icon icon-Arrow-right"></i>
      </div>
    </Link>
  );
};

export default CategoryItem;
